import { createContext, useContext } from 'react'
import type { EntityDef } from '../api/types'

export type DateMode = 'preset' | 'custom'

export const DATE_PRESETS = [
  'This fiscal year',
  'Last fiscal year',
  'This quarter',
  'Last quarter',
  'This month',
  'Last month',
]

export interface ExportDraft {
  entityType: string
  entity: EntityDef | null
  /** The prototype's entity-specific filter box, e.g. "P.O. NO." */
  reference: string
  dateMode: DateMode
  preset: string
  from: string
  to: string
}

export interface ExportWizard extends ExportDraft {
  entities: EntityDef[]
  /** The active company's id, or null before any company is connected. */
  companyId: string | null
  setEntityType: (name: string) => void
  setReference: (value: string) => void
  setDateMode: (mode: DateMode) => void
  setPreset: (preset: string) => void
  setFrom: (value: string) => void
  setTo: (value: string) => void
  reset: () => void
}

export const ExportWizardContext = createContext<ExportWizard | null>(null)

export function useExportWizard(): ExportWizard {
  const context = useContext(ExportWizardContext)
  if (!context) throw new Error('useExportWizard must be used inside the export route')
  return context
}
